// extracted by mini-css-extract-plugin
module.exports = {"root":"footer-module--root--24vR9","footer":"footer-module--footer--2r2aa"};